import React from 'react';

function RulerIcon() {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='24'
			fill='none'
			viewBox='0 0 24 24'
		>
			<path
				stroke='#141414'
				strokeLinecap='round'
				strokeWidth='1.5'
				d='M17.5 10.5l2 2M14 14l2 2m-5.5 1.5l2 2'
			></path>
			<path
				stroke='#141414'
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeWidth='1.5'
				d='M10.536 4.678c1.364-1.365 2.047-2.047 2.808-2.363a4.142 4.142 0 013.17 0c.761.316 1.444.998 2.808 2.363 1.365 1.364 2.047 2.047 2.363 2.808a4.142 4.142 0 010 3.17c-.316.761-.998 1.444-2.363 2.808l-5.857 5.858c-1.365 1.365-2.048 2.047-2.809 2.363a4.142 4.142 0 01-3.17 0c-.761-.316-1.444-.998-2.808-2.363-1.365-1.364-2.047-2.047-2.363-2.808a4.142 4.142 0 010-3.17c.316-.761.998-1.444 2.363-2.808l5.858-5.858z'
			></path>
		</svg>
	);
}

export default RulerIcon;
